export function ErrorFallback({ error }: { error: Error }) {
  return (
    <div
      role="alert"
      data-testid="error-boundary-fallback"
      style={{
        padding: '2rem',
        textAlign: 'center',
        fontFamily: 'sans-serif',
      }}
    >
      <h1>Something went wrong</h1>
      <p>The app encountered an unexpected error. Please refresh the page.</p>
      {import.meta.env.DEV && (
        <pre style={{ textAlign: 'left', marginTop: '1rem', fontSize: '0.75rem' }}>
          {error.message}
        </pre>
      )}
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{ marginTop: '1rem', padding: '0.5rem 1rem', cursor: 'pointer' }}
      >
        Reload
      </button>
    </div>
  );
}
